<template>
  <div class="weimeng-page">
    <div class="container" @click="bindClick" v-if="version >= 90">
      <img
        class="error"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f6d66b4a758653cbfea621369a8720ba.png"
        alt=""
      />
      <div class="text">页面出现错误,请点击重试</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      version: 0
    }
  },
  created() {
    this.getVersion()
  },
  methods: {
    bindClick() {
      this.$betterwe.loadWMHomeWebPage()
    },
    async getVersion() {
      let res = await this.$betterwe.getAppDevicesInfo().catch(() => {})
      if (res) {
        this.version = res.clientversion
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.weimeng-page {
  min-height: 100vh;
  background: #f7f7f7;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    .error {
      margin: 20vh auto 20px;
      width: 215px;
      height: 112px;
      object-fit: contain;
    }

    .text {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.6);
    }
  }
}
</style>
